import { render, staticRenderFns } from "./chosePay.vue?vue&type=template&id=3b5fb863&scoped=true"
import script from "./chosePay.vue?vue&type=script&lang=js"
export * from "./chosePay.vue?vue&type=script&lang=js"
import style0 from "./chosePay.vue?vue&type=style&index=0&id=3b5fb863&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5fb863",
  null
  
)

export default component.exports